
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.5169 6.09083C34.5169 6.09083 37.7544 4.82833 37.4836 7.89416C37.3944 9.15666 36.5852 13.5758 35.9552 18.355L33.7969 32.5133C33.7969 32.5133 33.6169 34.5875 31.9977 34.9483C30.3794 35.3083 27.9511 33.6858 27.5011 33.325C27.1411 33.0542 20.7561 28.9958 18.5077 27.0125C17.8777 26.4708 17.1577 25.3892 18.5977 24.1267L28.0411 15.1083C29.1202 14.025 30.1994 11.5 25.7027 14.5667L13.1111 23.1333C13.1111 23.1333 11.6719 24.0358 8.97441 23.2242L3.12775 21.42C3.12775 21.42 0.969411 20.0675 4.65691 18.715C13.6511 14.4767 24.7136 10.1483 34.5161 6.08999","fill":"currentColor"}})])
          )
        }
      }
    